export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/WSJ.99c0ac62.svg","height":50,"width":73};